import React, { useEffect } from 'react';

import { adaptHeightOnWidget } from '../lib/ep.js';

const WidgetHeightAdapter = (props) => {
	useEffect(() => {
		adaptHeightOnWidget();
	}, []);

	return props.children;
}

export default WidgetHeightAdapter;